import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { DataTable } from "@/components/common/DataTable";
import { buildTableDefaults } from "@/components/common/data-table-helpers";
import { cn } from "@/lib/utils";
import { useUserListColumns, useUserStore } from "../hooks";

const defaultPageSizeOptions = [10, 30, 50];

const UserTable = observer(
  ({
    pageSizeOptions = defaultPageSizeOptions,
    className,
    onViewUser,
    onDeleteUser,
  }) => {
    const { t } = useTran();
    const {
      users,
      usersLoading,
      sort,
      page,
      pageSize,
      usersTotal,
      setPage,
      setPageSize,
      setSort,
    } = useUserStore();
    const columns = useUserListColumns({ onViewUser, onDeleteUser });
    const { translate, emptyMessage, loadingMessage, getRowProps } =
      buildTableDefaults({
        t,
        emptyMessageKey: "No users found.",
      });

    const handlePageChange = (newPage) => {
      if (newPage !== page) {
        setPage(newPage);
      }
    };

    const handlePageSizeChange = (newSize) => {
      if (newSize !== pageSize) {
        setPageSize(newSize);
        setPage(1);
      }
    };

    const handleSort = (key) => {
      let direction = "asc";
      if (
        sort.key === key &&
        (sort.direction === "asc" || sort.direction === "ascending")
      ) {
        direction = "desc";
      }
      setSort({ key, direction });
      setPage(1);
    };

    return (
      <div
        className={cn(
          "overflow-hidden rounded-radius border border-border bg-card p-4",
          className,
        )}
      >
        <DataTable
          columns={columns}
          data={users}
          loading={usersLoading}
          sort={sort}
          onSort={handleSort}
          emptyMessage={emptyMessage}
          loadingMessage={loadingMessage}
          getRowKey={(row) => row?.id || row?.userId || row?._id}
          getRowProps={getRowProps}
          pagination={{
            page,
            pageSize,
            total: usersTotal,
            onPageChange: handlePageChange,
            onPageSizeChange: handlePageSizeChange,
            pageSizeOptions,
            disabled: usersLoading,
            labels: {
              itemsPerPage: translate("pagination.itemsPerPage"),
              previous: translate("Previous"),
              next: translate("Next"),
              pageLabel: ({ page: current, totalPages }) =>
                translate("pagination.pageLabel", {
                  page: current,
                  totalPages,
                }),
            },
          }}
        />
      </div>
    );
  },
);

export default UserTable;
